export const IMAGE_CIRCLE_DISPLAY = "imageCircle"
export const IMAGE_CIRCLE_SLOT_WIDTH = 164
export const IMAGE_CIRCLE_IMAGE_SIZE = 86
export const IMAGE_CIRCLE_MOBILE_IMAGE_SIZE = 190
export const IMAGE_CIRCLE_ITEM_MARGIN = 5

export const isImageCircleDisplay = (displayType?: string) => displayType === IMAGE_CIRCLE_DISPLAY

export const isImageCircleData = (data?: { desktopDisplayType?: string, displayType?: string, isImageCircle?: boolean }) =>
    !!(data && (data.isImageCircle || isImageCircleDisplay(data.desktopDisplayType) || isImageCircleDisplay(data.displayType)))

export const displayTypeForApp = (data: { displayType?: string, desktopDisplayType?: string, isImageCircle?: boolean } | undefined, fallback: string) => {
    if (isImageCircleData(data)) return IMAGE_CIRCLE_DISPLAY
    return (data && data.displayType) || fallback
}

export const tabletDisplayForApp = (data: { tabletDisplay?: string, desktopDisplayType?: string, displayType?: string, isImageCircle?: boolean } | undefined) => {
    if (isImageCircleData(data)) return IMAGE_CIRCLE_DISPLAY
    return (data && data.tabletDisplay) || "basic"
}

export const resolveEditableAuthor = (itemAuthor?: string, articleAuthor?: string) => {
    if (itemAuthor && itemAuthor.length > 0) return itemAuthor
    return articleAuthor || ""
}
